export default class BackgroundMedia {
  constructor(component) {
    this.dom = {
      $component: component,
      $image: component.querySelector('.js-bgImage'),
      $video: component.querySelector('.js-bgVideo')
    }
    this.state = {
      loadedImgSrc: '',
      loadedVideoSrc: '',
      loadedClass: 'isLoaded',
      observer: null,
      supportsIntersectionObserver:  ('IntersectionObserver' in window && 'isIntersecting' in window.IntersectionObserverEntry.prototype)
    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {state} = this

    if (state.supportsIntersectionObserver) {
      this.observe()
    } else {
      this.load()
    }

    window.addEventListener('resize', this.load.bind(this))
  }

  observe() {
    const {dom, state} = this
    state.observer = new IntersectionObserver(this.onIntersection.bind(this), {
      rootMargin: '250px'
    }),
    state.observer.observe(dom.$component)
  }

  onIntersection(entries) {
    const {state} = this
    const entry = entries[0]

    if (entry.isIntersecting) {
      this.load()
      state.observer.unobserve(entry.target)
    }
  }

  getImgSrc() {
    const {dom} = this
    const {
      image,
      mobileImage,
      tabletImage
    } = dom.$image.dataset
    let src = image

    if (window.innerWidth <= 500) {
      src = mobileImage ? mobileImage : src
    } else if (window.innerWidth <= 768) {
      src = tabletImage ? tabletImage : src
    }

    return src
  }

  getVideoSrc() {
    const {dom} = this
    const source = dom.$video.querySelector('source')
    let src = source.dataset.src

    if (window.innerWidth <= 500) {
      src = source.dataset.mobileSrc ? source.dataset.mobileSrc : src
    }

    return src
  }

  load() {
    const {dom} = this

    if (dom.$video) {
      this.loadVideo()
    } else if (dom.$image) {
      this.loadImage()
    }
  }

  loadImage() {
    const {dom, state} = this
    const src = this.getImgSrc()

    if (state.loadedImgSrc === src) return
    if (!src) return

    const image = new Image()
    image.src = src
    image.addEventListener('load', () => {
      dom.$image.style.backgroundImage = `url("${src}")`
      dom.$image.classList.add(state.loadedClass)
      state.loadedImgSrc = src
    })
  }

  async loadVideo() {
    const {dom, state} = this
    const src = this.getVideoSrc()

    if (state.loadedVideoSrc === src) return
    if (!src) return

    const source = dom.$video.querySelector('source')
    source.setAttribute('src', src)
    dom.$video.classList.add(state.loadedClass)
    dom.$video.load()
    await dom.$video.play()
    state.loadedVideoSrc = src
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.BackgroundMedia = this
  }
}
